import React from 'react'
import { Section } from '../../components/Section'
import { SectionContentImageWithText } from '../../components/SectionContentImageWithText'

export const SectionContentInstanceMissionStatement: React.FunctionComponent =
  () => (
    <Section backgroundColor="light-gray" padding={100}>
      <SectionContentImageWithText
        subheading="OUR MISSION"
        heading="We’re revolutionizing hospitality by connecting businesses and talent to unlock new opportunities, optimize efficiency, and achieve superior outcomes."
        imagePlacement="left"
        image={{
          publicId: 'photography/our-vision',
          alt: 'A manager training hospitality staff',
        }}
      />
    </Section>
  )
